module.exports = __webpack_public_path__ + "static/media/assassin_male.353adc69.png";